export const SPONSORED_AD_COMPONENTS_TRANSLATION_NAMESPACE = "sponsored-ad-components";
export const HEADER_FILTERS_TK = "HEADER_FILTERS_TK";
